var map = {
	"./br/PT/S1/fjbg.jpg": 75937,
	"./fjbg.jpg": 24969,
	"./in/EN/S1/fjbg.jpg": 75705,
	"./ph/EN/S1/fjbg.jpg": 17753,
	"./ph/EN/S2/fjbg.jpg": 56333,
	"./vn/VI/S1/fjbg.jpg": 44446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15001;